import { navigate } from '@redwoodjs/router'

import { getDefaultDateRange } from './loadFiltersFromUrl'

interface ExpirationFilters {
  statuses?: string[]
  categories?: string[]
  searchText?: string
  page?: number
  pageSize?: number
  sortField?: string | null
  sortDirection?: string | null
  expirationDateGte?: Date | null
  expirationDateLte?: Date | null
}

export function updateFiltersInUrl(filters: ExpirationFilters) {
  const searchParams = new URLSearchParams()

  const isDefaultStatuses =
    filters.statuses?.length === 1 && filters.statuses[0] === 'ACTIVE'
  if (filters.statuses && filters.statuses.length > 0 && !isDefaultStatuses) {
    searchParams.set('statuses', filters.statuses.join(','))
  }

  if (filters.categories && filters.categories.length > 0) {
    searchParams.set('categories', filters.categories.join(','))
  }

  if (filters.searchText) {
    searchParams.set('searchText', filters.searchText)
  }

  if (filters.page && filters.page > 1) {
    searchParams.set('page', String(filters.page))
  }

  if (filters.pageSize && filters.pageSize !== 20) {
    searchParams.set('pageSize', String(filters.pageSize))
  }

  if (filters.sortField) {
    searchParams.set('sortField', filters.sortField)
  }

  if (filters.sortDirection) {
    searchParams.set('sortDirection', filters.sortDirection)
  }

  // Only write date range to URL if it differs from the default ±60 day window
  const defaultRange = getDefaultDateRange()
  const isDefaultGte =
    filters.expirationDateGte &&
    Math.abs(filters.expirationDateGte.getTime() - defaultRange.gte.getTime()) <
      86400000
  const isDefaultLte =
    filters.expirationDateLte &&
    Math.abs(filters.expirationDateLte.getTime() - defaultRange.lte.getTime()) <
      86400000
  const isDefaultDateRange = isDefaultGte && isDefaultLte

  if (filters.expirationDateGte && !isDefaultDateRange) {
    searchParams.set('expirationDateGte', filters.expirationDateGte.toISOString())
  }

  if (filters.expirationDateLte && !isDefaultDateRange) {
    searchParams.set('expirationDateLte', filters.expirationDateLte.toISOString())
  }

  const qs = searchParams.toString()
  navigate(qs ? `?${qs}` : location.pathname, { replace: true })
}
